/** Matches Bootstrap `lg`. Below this, app chrome is hamburger + footer. */
export const WLJ_MOBILE_MAX_PX = 991;

export const isMobileViewportWidth = (width) => {
  const value = Number(width);
  if (Number.isFinite(value) && value > 0) {
    return value <= WLJ_MOBILE_MAX_PX;
  }
  if (typeof window !== "undefined") {
    return window.innerWidth <= WLJ_MOBILE_MAX_PX;
  }
  return false;
};
